export const gridPrint = {
  _ensurePrintButtonStyles: function () {
    if (document.getElementById('ag-print-btn-style')) return;
    const style = document.createElement('style');
    style.id = 'ag-print-btn-style';
    style.textContent = `
      .ag-print-controls { position: absolute; top: 6px; right: 40px; display: flex; gap: 6px; z-index: 5; }
      .ag-print-controls button { background: transparent; color: #ef4444; border: none; border-radius: 4px; width: 26px; height: 26px; padding: 0; cursor: pointer; display: inline-flex; align-items: center; justify-content: center; }
      .ag-print-controls button:hover { background: #f3f4f6; }
      .ag-print-controls button.alt { color: #6b7280; }
      .ag-print-controls i { font-size: 18px; line-height: 1; }
      [data-disable-print="true"] .ag-print-controls,
      [data-disable-print="true"] .ag-print-inline-btn[data-role="print"],
      [data-disable-print="true"] .ag-print-inline-btn[data-role="print-exit"] { display: none !important; }
      /* inline toolbar variant */
      .ag-print-inline-btn { background: #fff; color: #ef4444; border: 1px solid #e5e7eb; width: 28px; height: 28px; border-radius: 9999px; display: inline-flex; align-items: center; justify-content: center; padding: 0; margin-left: 6px; }
      .ag-print-inline-btn:hover { background: #f9fafb; }
      .ag-print-inline-btn.alt { color: #6b7280; }
      /* hide JS-injected inline PDF icon by default (using server-rendered toolbar button instead) */
      .ag-print-inline-btn[data-role='print'] { display: none !important; }
      /* spinner overlay shown while preparing print */
      .ag-print-spinner-overlay { position: fixed; inset: 0; background: rgba(255,255,255,0.6); display: flex; align-items: center; justify-content: center; z-index: 10000; }
      .ag-print-spinner { width: 36px; height: 36px; border: 3px solid #e5e7eb; border-top-color: #2563eb; border-radius: 50%; animation: ag-spin 0.8s linear infinite; }
      @keyframes ag-spin { to { transform: rotate(360deg); } }
      @media print { .ag-print-spinner-overlay { display: none !important; } }
    `;
    document.head.appendChild(style);
  },
  _injectPrintButtons: function (el) {
    try {
      if (el && el.dataset && el.dataset.disablePrint === 'true') {
        el.querySelectorAll('.ag-print-controls, .ag-print-inline-btn[data-role="print"], .ag-print-inline-btn[data-role="print-exit"]').forEach((node) => node.remove());
        return;
      }
      this._ensurePrintButtonStyles();
      try {
        const cs = window.getComputedStyle(el);
        if (cs && (cs.position === 'static' || !cs.position)) {
          el.style.position = 'relative';
        }
      } catch (_e) {}

      if (el.querySelector('.ag-print-controls') || el.querySelector('.ag-print-inline-btn[data-role="print"]')) return;

      const btnPrint = document.createElement('button');

      const btnNormal = document.createElement('button');
      btnNormal.className = 'alt';
      btnNormal.setAttribute('aria-label', 'Exit print layout');
      btnNormal.setAttribute('title', 'Exit print layout');
      btnNormal.style.display = 'none';
      btnNormal.innerHTML = '<i class="bi bi-x-lg" aria-hidden="true"></i>';

      btnPrint.addEventListener('click', () => {
        try { window.ag.setPrintLayout(el); } catch (_e) {}
        btnPrint.style.display = 'none';
        btnNormal.style.display = 'inline-flex';
      });

      btnNormal.addEventListener('click', () => {
        try { window.ag.resetPrintLayout(el); } catch (_e) {}
        btnNormal.style.display = 'none';
        btnPrint.style.display = 'inline-flex';
      });

      const downloadIcon = el.querySelector('button i.bi-download, button i.bi-cloud-download, button i.bi-file-earmark-arrow-down, button i.bi-cloud-arrow-down');
      const gridIcon = el.querySelector('button i.bi-gear, button i.bi-gear-fill, button i.bi-sliders, button i.bi-sliders2');
      const anchorBtn = (downloadIcon && downloadIcon.closest('button')) || (gridIcon && gridIcon.closest('button'));
      const toolbar = anchorBtn ? anchorBtn.parentElement : null;

      if (toolbar) {
        btnPrint.className = 'ag-print-inline-btn';
        btnPrint.dataset.role = 'print';
        btnNormal.className = 'ag-print-inline-btn alt';
        btnNormal.dataset.role = 'print-exit';
        toolbar.insertBefore(btnPrint, anchorBtn.nextSibling);
        toolbar.insertBefore(btnNormal, btnPrint.nextSibling);
      } else {
        const ctr = document.createElement('div');
        ctr.className = 'ag-print-controls';
        ctr.appendChild(btnPrint);
        ctr.appendChild(btnNormal);
        el.appendChild(ctr);
      }
    } catch (_e) {}
  },

  // ----- Print helpers (AG Grid print layout) ---------------------------------
  _resolveGridElement: function (elOrId) {
    if (!elOrId) return null;
    if (elOrId instanceof HTMLElement) return elOrId;
    let el = document.querySelector(`[data-ag-id='${elOrId}']`) || document.getElementById(elOrId);
    return el || null;
  },

  _relaxAncestorsForPrint: function (el) {
    const changed = [];
    let node = el;
    let hops = 0;
    while (node && node !== document.body && hops < 20) {
      const style = node.style || {};
      const snapshot = {
        node,
        height: style.height,
        maxHeight: style.maxHeight,
        overflow: style.overflow,
        overflowY: style.overflowY,
        overflowX: style.overflowX,
      };
      changed.push(snapshot);
      try {
        style.height = 'auto';
        style.maxHeight = 'none';
        style.overflow = 'visible';
        style.overflowY = 'visible';
        style.overflowX = 'visible';
      } catch (_e) {}
      node = node.parentElement;
      hops += 1;
    }
    el.__printAncestors = changed;
  },

  _restoreAncestorsAfterPrint: function (el) {
    const list = el.__printAncestors || [];
    for (const s of list) {
      try {
        s.node.style.height = s.height;
        s.node.style.maxHeight = s.maxHeight;
        s.node.style.overflow = s.overflow;
        s.node.style.overflowY = s.overflowY;
        s.node.style.overflowX = s.overflowX;
      } catch (_e) {}
    }
    delete el.__printAncestors;
  },

  _hideNonGridSiblings: function (el) {
    const hidden = [];
    let node = el;
    let hops = 0;
    while (node && node !== document.body && hops < 20) {
      const parent = node.parentElement;
      if (!parent) break;
      const children = Array.from(parent.children || []);
      for (const child of children) {
        if (child === node) continue;
        hidden.push({ node: child, display: child.style.display });
        try { child.style.display = 'none'; } catch (_e) {}
      }
      node = parent;
      hops += 1;
    }
    el.__printHiddenSiblings = hidden;
  },

  _restoreHiddenSiblings: function (el) {
    const list = el.__printHiddenSiblings || [];
    for (const item of list) {
      try { item.node.style.display = item.display; } catch (_e) {}
    }
    delete el.__printHiddenSiblings;
  },

  _showPrintSpinner: function (el) {
    try {
      try { this._ensurePrintButtonStyles(); } catch (_e) {}
      const gridId = el?.dataset?.agId || 'global';
      const existing = document.getElementById(`ag-print-spinner-${gridId}`);
      if (existing) return;
      const ov = document.createElement('div');
      ov.className = 'ag-print-spinner-overlay';
      ov.id = `ag-print-spinner-${gridId}`;
      ov.innerHTML = '<div class="ag-print-spinner" aria-label="Preparing print..."></div>';
      const host = el || document.body;
      host.appendChild(ov);
    } catch (_e) {}
  },
  _hidePrintSpinner: function (el) {
    try {
      const gridId = el?.dataset?.agId || 'global';
      const ov = document.getElementById(`ag-print-spinner-${gridId}`);
      if (ov && ov.parentNode) ov.parentNode.removeChild(ov);
    } catch (_e) {}
  },

  // ----- Column width constraints (print-only) ---------------------------------
  _parsePrintMaxWidths: function (el) {
    try {
      const raw = el?.dataset?.printMaxwidths || el?.getAttribute?.('data-print-maxwidths');
      if (!raw) return {};
      let map = {};
      try {
        const obj = JSON.parse(raw);
        if (obj && typeof obj === 'object') return obj;
      } catch (_e) {}
      // fallback: csv like "colA:240,colB:180"
      const parts = String(raw).split(',');
      for (const p of parts) {
        const [k, v] = p.split(':');
        if (!k || !v) continue;
        const key = k.trim();
        const val = parseInt(String(v).trim(), 10);
        if (key && Number.isFinite(val)) map[key] = val;
      }
      return map;
    } catch (_e) { return {}; }
  },

  _applyPrintMaxWidths: function (el) {
    try {
      const gridId = el?.dataset?.agId;
      if (!gridId) return;
      // HTML print table already uses width:100% table-layout:fixed — no zoom needed
      if (el.__printTable) return;
      const api = window[`aggridApi:${gridId}`];
      const PRINT_PAGE_WIDTH = 1100;

      let totalWidth = 0;
      try {
        const rw = el.querySelector('.ag-root-wrapper');
        if (rw) totalWidth = Math.max(rw.scrollWidth || 0, rw.offsetWidth || 0);
      } catch (_e) {}
      
      if (!totalWidth) {
        try {
          const cols = (typeof api.getAllDisplayedColumns === 'function')
            ? api.getAllDisplayedColumns() : [];
          totalWidth = cols.reduce((sum, c) => {
            try { return sum + (c.getActualWidth ? c.getActualWidth() : 100); }
            catch (_e) { return sum + 100; }
          }, 0);
        } catch (_e) {}
      }

      if (totalWidth <= PRINT_PAGE_WIDTH || totalWidth === 0) return;

     
      const zoom = PRINT_PAGE_WIDTH / totalWidth;
      // Apply zoom to print table if it exists, otherwise to grid element
      const target = el.__printTable || el;
      if (!target.__printScaleOrig) {
        target.__printScaleOrig = { zoom: target.style.zoom || '', width: target.style.width || '' };
      }
      target.style.zoom = zoom.toFixed(4);
      target.style.setProperty('width', totalWidth + 'px', 'important');
    } catch (_e) {}
  },

  _restorePrintMaxWidths: function (el) {
    try {
      // Restore zoom from print table or grid element
      const target = (el.__printTable && el.__printTable.__printScaleOrig) ? el.__printTable : el;
      if (target.__printScaleOrig) {
        target.style.zoom = target.__printScaleOrig.zoom;
        target.style.removeProperty('width');
        if (target.__printScaleOrig.width) {
          target.style.width = target.__printScaleOrig.width;
        }
        delete target.__printScaleOrig;
      }
    } catch (_e) {}
  },

  // Compute and set uniform row heights based on wrapped cell contents (print only)
  _fixRowHeightsForPrint: function (el) {
    try {
      if (!el) return;
      const centerContainer = el.querySelector('.ag-center-cols-container');
      const leftContainer = el.querySelector('.ag-pinned-left-cols-container');
      const rightContainer = el.querySelector('.ag-pinned-right-cols-container');
      if (!centerContainer) return;
      const centerRows = Array.from(centerContainer.querySelectorAll('.ag-row'));
      const byAttr = (row, attr) => row && row.getAttribute && row.getAttribute(attr);
      const findSiblingRow = (container, centerRow) => {
        if (!container || !centerRow) return null;
        const attrs = ['row-index', 'row-id', 'aria-rowindex'];
        for (const a of attrs) {
          const val = byAttr(centerRow, a);
          if (val != null) {
            const m = container.querySelector(`.ag-row[${a}='${val}']`);
            if (m) return m;
          }
        }
        const idx = centerRows.indexOf(centerRow);
        return (idx >= 0) ? (container.querySelectorAll('.ag-row')[idx] || null) : null;
      };
      const measureRow = (row) => {
        let maxContentH = 0;
        let maxPad = 0;
        const cells = Array.from(row.querySelectorAll('.ag-cell'));
        for (const cell of cells) {
          const content = cell.querySelector('.ag-cell-value, .ag-group-value') || cell;
          const prev = {
            height: content.style.height,
            overflow: content.style.overflow,
            whiteSpace: content.style.whiteSpace,
            display: content.style.display,
            maxHeight: content.style.maxHeight,
          };
          try {
            content.style.height = 'auto';
            content.style.overflow = 'visible';
            content.style.whiteSpace = 'normal';
            content.style.display = 'block';
            content.style.maxHeight = 'none';
            const h = Math.max(content.scrollHeight || 0, content.getBoundingClientRect().height || 0);
            if (h > maxContentH) maxContentH = h;
          } catch (_e) {}
          content.style.height = prev.height;
          content.style.overflow = prev.overflow;
          content.style.whiteSpace = prev.whiteSpace;
          content.style.display = prev.display;
          content.style.maxHeight = prev.maxHeight;

          try {
            const cs = window.getComputedStyle(cell);
            const pad = (parseFloat(cs.paddingTop) || 0) + (parseFloat(cs.paddingBottom) || 0) +
                        (parseFloat(cs.borderTopWidth) || 0) + (parseFloat(cs.borderBottomWidth) || 0);
            if (pad > maxPad) maxPad = pad;
          } catch (_e) {}
        }
        // dynamic margin: tighter for single-line rows, slight extra for multi-line
        const baseMargin = 7;
        // measure line-height baseline for this row
        let maxLine = 0;
        try {
          const sample = row.querySelectorAll('.ag-cell');
          sample.forEach(cell => {
            try { const lh = parseFloat(window.getComputedStyle(cell).lineHeight) || 0; if (lh > maxLine) maxLine = lh; } catch (_e) {}
          });
        } catch (_e) {}
        const unit = maxLine > 0 ? maxLine : 16;
        const contentRaw = maxContentH + maxPad;
        const lines = Math.ceil(contentRaw / unit) || 1;
        const extra = lines > 1 ? 2 : 0; // bump for multi-line to avoid clipping
        const target = lines * unit + baseMargin + extra;
        return Math.max(26, Math.ceil(target));
      };
      const rowEntries = [];
      let uniformH = 32;
      for (const cRow of centerRows) {
        const lRow = findSiblingRow(leftContainer, cRow);
        const rRow = findSiblingRow(rightContainer, cRow);
        const allRows = [cRow, lRow, rRow].filter(Boolean);
        const heights = allRows.map(measureRow);
        const targetH = Math.max.apply(null, heights.length ? heights : [32]);
        if (targetH > uniformH) uniformH = targetH;
        rowEntries.push({ rows: allRows, targetH });
      }

      for (const entry of rowEntries) {
        const h = uniformH;
        for (const row of entry.rows) {
          try {
            row.style.setProperty('height', `${h}px`, 'important');
            row.style.setProperty('min-height', `${h}px`, 'important');
            row.style.setProperty('max-height', `${h}px`, 'important');
            const cells = row.querySelectorAll('.ag-cell, .ag-cell-wrapper, .ag-cell-value, .ag-group-value');
            cells.forEach(cell => {
              try {
                cell.style.setProperty('height', `${h}px`, 'important');
                cell.style.setProperty('max-height', `${h}px`, 'important');
                cell.style.setProperty('overflow', 'hidden', 'important');
              } catch (_e) {}
            });
          } catch (_e) {}
        }
      }
    } catch (_e) {}
  },

  // Build a proper HTML <table> from AG Grid's rendered print DOM.
  // Solves: (1) header repetition on every printed page via <thead>,
  //         (2) natural text wrapping in table cells (no overflow:hidden clipping).
  _buildPrintTable: function (el) {
    try {
      if (!el) return;
      const gridId = el.dataset.agId;
      const api = window[`aggridApi:${gridId}`];
      if (!api) return;

      // Inject CSS once
      if (!document.getElementById('ag-print-table-style')) {
        const s = document.createElement('style');
        s.id = 'ag-print-table-style';
        s.textContent = `
          .ag-print-table { width: 100%; border-collapse: collapse; border: 3px solid #888; }
          .ag-print-table thead { display: table-header-group; }
          .ag-print-table th {
            font-size: 16px; font-weight: 700; border: 1px solid #cbd5e1;
            padding: 6px 8px; white-space: normal; word-break: normal;
            background: #fff; color: #000; vertical-align: middle; line-height: 1.3;
          }
          .ag-print-table td {
            border: 1px solid #cbd5e1; padding: 6px 8px; font-size: 18px;
            white-space: normal; word-break: break-word; overflow-wrap: anywhere;
            vertical-align: top; background: white; color: black; line-height: 1.5;
          }
          .ag-print-table tbody tr { page-break-inside: avoid; break-inside: avoid; }
          .ag-print-table-active .ag-root-wrapper { display: none !important; height: 0 !important; overflow: hidden !important; }
          @media print {
            .ag-print-table { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
            .ag-print-table thead tr:first-child th { padding-top: 14px; }
            .ag-print-table-active .ag-root-wrapper { display: none !important; height: 0 !important; overflow: hidden !important; }
          }
        `;
        document.head.appendChild(s);
      }

      // Guard against duplicate table builds
      if (el.__printTable) return;

      // Get displayed columns ordered: pinned-left, center, pinned-right
      const allCols = (typeof api.getAllDisplayedColumns === 'function')
        ? api.getAllDisplayedColumns() : [];
      if (!allCols.length) return;

      const cols = allCols
        .filter(c => {
          const id = c.getColId ? c.getColId() : '';
          const def = c.getColDef ? c.getColDef() : {};
          if (!id) return false;
          if (id.indexOf('ag-Grid-SelectionColumn') !== -1) return false;
          if (!def.field && (def.headerCheckboxSelection || def.checkboxSelection)) return false;
          return true;
        })
        .sort((a, b) => {
          const order = { left: 0, null: 1, right: 2 };
          const pa = a.getPinned ? a.getPinned() : null;
          const pb = b.getPinned ? b.getPinned() : null;
          return (order[pa] || 1) - (order[pb] || 1);
        });

      if (!cols.length) return;

      // Calculate proportional column widths
      const totalWidth = cols.reduce((sum, c) => {
        return sum + (c.getActualWidth ? c.getActualWidth() : 100);
      }, 0);

      // Build <colgroup>
      const colgroup = document.createElement('colgroup');
      for (const c of cols) {
        const col = document.createElement('col');
        const w = c.getActualWidth ? c.getActualWidth() : 100;
        col.style.width = ((w / totalWidth) * 100).toFixed(2) + '%';
        colgroup.appendChild(col);
      }

      // Build <thead>
      const thead = document.createElement('thead');

      // Check for grouped header rows
      const groupRow = el.querySelector('.ag-header-row-column-group');
      if (groupRow) {
        const tr = document.createElement('tr');
        const groupCells = Array.from(groupRow.querySelectorAll('.ag-header-group-cell'));
        for (const gc of groupCells) {
          const th = document.createElement('th');
          const textEl = gc.querySelector('.ag-header-group-text');
          th.textContent = textEl ? textEl.textContent : gc.textContent || '';
          const span = gc.getAttribute('aria-colspan') || gc.getAttribute('colspan');
          if (span && parseInt(span) > 1) th.setAttribute('colspan', span);
          tr.appendChild(th);
        }
        thead.appendChild(tr);
      }

      // Leaf header row
      const headTr = document.createElement('tr');
      for (const c of cols) {
        const colId = c.getColId ? c.getColId() : '';
        const th = document.createElement('th');
        // Try reading from DOM first (may have custom header renderer)
        const headerCell = el.querySelector(`.ag-header-cell[col-id="${colId}"] .ag-header-cell-text`);
        if (headerCell) {
          th.textContent = headerCell.textContent || '';
        } else {
          const def = c.getColDef ? c.getColDef() : {};
          th.textContent = def.headerName || colId;
        }
        headTr.appendChild(th);
      }
      thead.appendChild(headTr);

      // Build <tbody> from rendered rows
      const tbody = document.createElement('tbody');
      const centerContainer = el.querySelector('.ag-center-cols-container');
      const leftContainer = el.querySelector('.ag-pinned-left-cols-container');
      const rightContainer = el.querySelector('.ag-pinned-right-cols-container');
      if (!centerContainer) return;

      const centerRows = Array.from(centerContainer.querySelectorAll(':scope > .ag-row'));
      centerRows.sort((a, b) => {
        return parseInt(a.getAttribute('row-index') || '0') - parseInt(b.getAttribute('row-index') || '0');
      });

      const findRow = (container, refRow) => {
        if (!container) return null;
        const attrs = ['row-index', 'row-id', 'aria-rowindex'];
        for (const a of attrs) {
          const val = refRow.getAttribute(a);
          if (val != null) {
            const m = container.querySelector(`:scope > .ag-row[${a}='${val}']`);
            if (m) return m;
          }
        }
        return null;
      };

      // Helper: get display value for a cell via AG Grid API (bypasses DOM rendering issues)
      const getCellText = (rowNode, col) => {
        try {
          if (!rowNode || !rowNode.data) return '';
          const colDef = col.getColDef ? col.getColDef() : {};
          const field = colDef.field || (col.getColId ? col.getColId() : '');
          if (!field) return '';
          let value = rowNode.data[field];
          if (value == null) return '';
          // Apply valueFormatter if present
          if (typeof colDef.valueFormatter === 'function') {
            try {
              value = colDef.valueFormatter({ value, data: rowNode.data, node: rowNode, colDef, column: col });
              if (value == null) return '';
            } catch (_e) {}
          } else if (colDef.cellRenderer === 'agCheckboxCellRenderer' && typeof value === 'boolean') {
            return value ? 'Yes' : 'No';
          }
          return String(value);
        } catch (_e) { return ''; }
      };

      for (const cRow of centerRows) {
        const lRow = findRow(leftContainer, cRow);
        const rRow = findRow(rightContainer, cRow);

        // Skip pinned-bottom rows (handled separately as totals below)
        if (cRow.getAttribute('row-pinned') === 'bottom') continue;

        // Footer/total rows from row grouping — style bold with top border
        const isFooter = cRow.classList.contains('ag-row-footer') || cRow.classList.contains('ag-row-group-footer');

        // Check if this is a group row (spans full width)
        if (cRow.classList.contains('ag-row-group')) {
          const tr = document.createElement('tr');
          const td = document.createElement('td');
          td.setAttribute('colspan', String(cols.length));
          const groupCell = cRow.querySelector('.ag-group-value') || cRow.querySelector('.ag-cell-value') || cRow;
          td.textContent = (groupCell.textContent || '').trim();
          td.style.fontWeight = '600';
          tr.appendChild(td);
          tbody.appendChild(tr);
          continue;
        }

        // Resolve the AG Grid row node for API-based value extraction
        const rowIndex = parseInt(cRow.getAttribute('row-index') || '0');
        const rowNode = (typeof api.getDisplayedRowAtIndex === 'function') ? api.getDisplayedRowAtIndex(rowIndex) : null;

        const tr = document.createElement('tr');
        if (isFooter) {
          tr.style.fontWeight = '700';
          tr.style.borderTop = '2px solid #000';
        }
        for (const c of cols) {
          const colId = c.getColId ? c.getColId() : '';
          const pinned = c.getPinned ? c.getPinned() : null;
          const container = pinned === 'left' ? lRow : pinned === 'right' ? rRow : cRow;
          const td = document.createElement('td');

          // Try DOM extraction first
          let text = '';
          const colDef = c.getColDef ? c.getColDef() : {};
          const isCheckbox = colDef.cellRenderer === 'agCheckboxCellRenderer';
          if (container) {
            const cell = container.querySelector(`.ag-cell[col-id="${colId}"]`);
            if (cell) {
              const content = cell.querySelector('.ag-cell-value') || cell.querySelector('.ag-group-value') || cell;
              text = (content.textContent || '').trim();
            }
          }
          // Checkbox columns: convert true/false to Yes/No
          if (isCheckbox) {
            const lower = text.toLowerCase();
            if (lower === 'true' || lower === '1') text = 'Yes';
            else if (lower === 'false' || lower === '0' || !text) text = 'No';
          }
          // Fallback: get value directly from AG Grid API
          if (!text) {
            text = getCellText(rowNode, c);
          }

          td.textContent = text;
          tr.appendChild(td);
        }
        tbody.appendChild(tr);
      }

      // Floating bottom (totals) rows — merge into a single bold row
      const floatBottom = el.querySelector('.ag-floating-bottom-container');
      if (floatBottom) {
        const bottomRows = Array.from(floatBottom.querySelectorAll(':scope > .ag-row'));
        if (bottomRows.length) {
          // Collect cell values from all bottom rows, keeping non-empty values
          const merged = {};
          for (const bRow of bottomRows) {
            for (const c of cols) {
              const colId = c.getColId ? c.getColId() : '';
              const cell = bRow.querySelector(`.ag-cell[col-id="${colId}"]`);
              if (cell) {
                const content = cell.querySelector('.ag-cell-value') || cell.querySelector('.ag-group-value') || cell;
                const text = (content.textContent || '').trim();
                if (text && !merged[colId]) merged[colId] = text;
              }
            }
          }
          const tr = document.createElement('tr');
          tr.style.fontWeight = '700';
          tr.style.borderTop = '2px solid #000';
          for (const c of cols) {
            const colId = c.getColId ? c.getColId() : '';
            const td = document.createElement('td');
            td.textContent = merged[colId] || '';
            tr.appendChild(td);
          }
          tbody.appendChild(tr);
        }
      }

      // Assemble table
      const table = document.createElement('table');
      table.className = 'ag-print-table';
      table.id = `ag-print-table-${gridId}`;
      table.appendChild(colgroup);
      table.appendChild(thead);
      table.appendChild(tbody);

      // Hide AG Grid's div-based layout via class on parent (survives AG Grid DOM rebuilds)
      el.classList.add('ag-print-table-active');

      // Insert table in correct position (after label, before footer)
      const footer = el.querySelector('.jobcard-print-footer');
      if (footer) {
        el.insertBefore(table, footer);
      } else {
        el.appendChild(table);
      }

      el.__printTable = table;

      // Optional signature row at the end of the report (after the table, last page).
      // Forms opt in via data-print-signatories so other grids are unaffected.
      let signatories = [];
      try { signatories = el?.dataset?.printSignatories ? JSON.parse(el.dataset.printSignatories) : []; } catch (_e) {}
      if (signatories.length) {
        const sigEl = document.createElement('div');
        sigEl.className = 'ag-print-signatories';
        signatories.forEach(function (name) {
          const span = document.createElement('span');
          span.textContent = name;
          sigEl.appendChild(span);
        });
        table.parentNode.insertBefore(sigEl, table.nextSibling);
        el.__printSignatories = sigEl;
      }
    } catch (_e) {}
  },

  _removePrintTable: function (el) {
    try {
      if (!el) return;
      if (el.__printTable) {
        el.__printTable.remove();
        delete el.__printTable;
      }
      if (el.__printSignatories) {
        el.__printSignatories.remove();
        delete el.__printSignatories;
      }
      el.classList.remove('ag-print-table-active');
    } catch (_e) {}
  },

  _clearFixedRowHeights: function (el) {
    try {
      if (!el) return;
      const rows = el.querySelectorAll('.ag-row');
      rows.forEach(r => {
        try { r.style.removeProperty('height'); r.style.removeProperty('min-height'); r.style.removeProperty('max-height'); } catch (_e) {}
      });
      const cells = el.querySelectorAll('.ag-cell, .ag-cell-wrapper, .ag-cell-value, .ag-group-value');
      cells.forEach(c => {
        try { c.style.removeProperty('height'); c.style.removeProperty('min-height'); c.style.removeProperty('max-height'); c.style.removeProperty('overflow'); } catch (_e) {}
      });
    } catch (_e) {}
  },

  setPrintLayout: function (elOrId) {
    const el = this._resolveGridElement(elOrId);
    if (!el) return;
    const _printMonths = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    const _fmtPrintDate = function(v) {
      if (!v) return '';
      var d = (v instanceof Date) ? v : new Date(v);
      if (isNaN(d.getTime())) return v;
      return String(d.getDate()).padStart(2,'0') + '-' + _printMonths[d.getMonth()] + '-' + d.getFullYear();
    };
    const gridId = el.dataset.agId;
    const api = window[`aggridApi:${gridId}`];
    if (!api) return;

    const wrapper = el;
    el.__printState = {
      width: wrapper.style.width,
      height: wrapper.style.height,
      sideBarVisible: undefined,
    };
    try {
      if (typeof api.isSideBarVisible === 'function' && typeof api.setSideBarVisible === 'function') {
        el.__printState.sideBarVisible = api.isSideBarVisible();
        api.setSideBarVisible(false);
      }
      if (typeof api.expandAll === 'function') api.expandAll();
    } catch (_e) {}

    try {
      const viewports = Array.from(el.querySelectorAll('.ag-body-viewport, .ag-center-cols-viewport'));
      el.__printScroll = {
        pageX: window.scrollX,
        pageY: window.scrollY,
        viewports: viewports.map(v => ({ node: v, top: v.scrollTop, left: v.scrollLeft })),
      };
      try { window.scrollTo(0, 0); } catch (_e) {}
      for (const v of viewports) {
        try { v.scrollTop = 0; v.scrollLeft = 0; } catch (_e) {}
      }
    } catch (_e) {}

    api.setGridOption('domLayout', 'print');

    wrapper.style.width = '';
    wrapper.style.height = '';

    this._relaxAncestorsForPrint(wrapper);
    this._hideNonGridSiblings(wrapper);

    if (!document.getElementById('ag-print-style')) {
      const style = document.createElement('style');
      style.id = 'ag-print-style';
      style.textContent = `@media print {
        html, body { height: auto !important; overflow: visible !important; margin: 0 !important; padding: 0 !important; }
      
        [data-ag-id] .ag-root-wrapper {
          border: 3px solid #888 !important;
        }
      
        [data-ag-id], .ag-root-wrapper, .ag-root, .ag-center-cols-viewport, .ag-center-cols-container,
        .ag-body, .ag-body-viewport, .ag-body-vertical-scroll,
        .ag-body-vertical-scroll-viewport, .ag-body-horizontal-scroll,
        .ag-body-horizontal-scroll-viewport {
          height: auto !important;
          max-height: none !important;
          overflow: visible !important;
        }
      
        .ag-print-controls { display: none !important; }
      }`;
      document.head.appendChild(style);
    }

    if (!document.getElementById('ag-print-page-style')) {
      const pageStyle = document.createElement('style');
      pageStyle.id = 'ag-print-page-style';
      pageStyle.textContent = `@page { size: landscape; margin: 0.25in; }`;
      document.head.appendChild(pageStyle);
    }

    try {
      el.__printState.pagination = !!api.getGridOption('pagination');
      if (el.__printState.pagination) {
        api.setGridOption('pagination', false);
      }
    } catch (_e) {}

    const focusStyleId = `ag-print-focus-style-${gridId}`;
    if (!document.getElementById(focusStyleId)) {
      const s = document.createElement('style');
      s.id = focusStyleId;
      s.textContent = `@media print {\n  html, body { margin: 0 !important; padding: 0 !important; background: white !important; }\n  body * { visibility: hidden !important; }\n  [data-ag-id='${gridId}'] { visibility: visible !important; position: static !important; width: 100% !important; margin: 0 !important; padding: 0 !important; }\n  [data-ag-id='${gridId}'] * { visibility: visible !important; }\n  [data-ag-id='${gridId}'] .ag-root-wrapper { position: static !important; min-width: 100% !important; margin: 0 !important; padding: 0 !important; border: none !important; background: white !important; }\n  [data-ag-id='${gridId}'].ag-print-table-active .ag-root-wrapper,\n  [data-ag-id='${gridId}'].ag-print-table-active .ag-root-wrapper * { display: none !important; visibility: hidden !important; height: 0 !important; overflow: hidden !important; }\n  [data-ag-id='${gridId}'].ag-print-table-active .ag-row-group-panel,\n  [data-ag-id='${gridId}'].ag-print-table-active .ag-side-bar,\n  [data-ag-id='${gridId}'].ag-print-table-active .ag-floating-filter,\n  [data-ag-id='${gridId}'].ag-print-table-active .ag-status-bar,\n  [data-ag-id='${gridId}'].ag-print-table-active .ag-selection-checkbox { display: none !important; }\n  /* tighten header spacing */\n  [data-ag-id='${gridId}'] .ag-header,\n  [data-ag-id='${gridId}'] .ag-header-viewport { margin: 0 !important; padding: 0 !important; height: 24px !important; min-height: 24px !important; }\n  [data-ag-id='${gridId}'] .ag-header-row { height: 24px !important; min-height: 24px !important; }\n  [data-ag-id='${gridId}'] .ag-header-cell,\n  [data-ag-id='${gridId}'] .ag-cell { padding-top: 0 !important; padding-bottom: 0 !important; }\n}`;
      document.head.appendChild(s);
    }

    try { document.body.classList.add('ag-printing'); } catch (_e) {}

    // Optional print title/logo injection
    try {
      if (!document.getElementById('ag-print-title-style')) {
        const ts = document.createElement('style');
        ts.id = 'ag-print-title-style';
        ts.textContent = `@media print { .ag-print-titlebar { position: relative; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 2px; margin: 8px 0 8px 0; padding-top: 4px; min-height: 96px; } .ag-print-company-name { text-align: center; font-weight: 800; font-size: 36px; text-transform: uppercase; } .ag-print-company-address { text-align: center; font-size: 20px; color: #333; margin-bottom: 2px; } .ag-print-title { text-align: center; font-weight: 800; font-size: 34px; } .ag-print-subtitle { text-align: center; font-weight: 700; font-size: 24px; margin-top: 2px; } .ag-print-logo { position: absolute; left: 16px; top: 50%; transform: translateY(-50%); max-height: 96px; max-width: 220px; height: auto; width: auto; object-fit: contain; }
        .ag-print-iso-label {
        position: absolute;
        top: -4px;
        right: 30px;
        color: #000;
        font-weight: 700;
        font-size: 22px;
        line-height: 1.4;
        text-align: right;
    }

    .ag-print-iso-code {
        font-weight: 700;
        font-size: 22px;
        line-height: 1.4;
    }
    .ag-print-iso-code + .ag-print-iso-code {
        display: block;
    }
    .ag-print-footer {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        text-align: right;
        font-size: 9px;
        color: #000;
        padding: 4px 10px;
        border-top: 1px solid #ccc;
        visibility: visible !important;
        z-index: 99999;
    }
    .ag-print-signatories {
        display: flex;
        justify-content: space-between;
        margin-top: 150px;
        padding-top: 16px;
        border-top: 1px solid #000;
        font-size: 20px;
        font-weight: 700;
        page-break-inside: avoid;
        break-inside: avoid;
    }
    .ag-print-signatories span { min-width: 14%; text-align: center; }
        } }`;
        document.head.appendChild(ts);
      }
      let titleText = el?.dataset?.printTitle || '';
      if (!titleText) {
        const getFormNameFromEl = (node) => {
          if (!node) return '';
          if (node.dataset && node.dataset.formname) return node.dataset.formname;
          const withAttr = node.querySelector && node.querySelector('[data-formname]');
          if (withAttr && withAttr.getAttribute('data-formname')) return withAttr.getAttribute('data-formname');
          const formInput = node.querySelector && node.querySelector('input[name="formname"], [name="formname"]');
          if (formInput) return formInput.value || '';
          return '';
        };
        let current = el;
        while (!titleText && current) {
          titleText = getFormNameFromEl(current);
          current = current.parentElement;
        }
        if (!titleText) titleText = getFormNameFromEl(document);
      }
      if (titleText) {
        const titleId = `ag-print-title-${gridId}`;
        let titleEl = document.getElementById(titleId);
        if (!titleEl) {
          const titleBar = document.createElement('div');
          titleBar.id = titleId;
          titleBar.className = 'ag-print-titlebar';
          const logoSrc = el?.dataset?.printLogo ||
                          document.querySelector('img[data-client-logo]')?.src ||
                          document.querySelector('[data-client-logo]')?.getAttribute('data-client-logo') ||
                          document.querySelector('img.client-logo, img[alt*="logo" i]')?.getAttribute('src') || '';
          if (logoSrc) {
            const img = document.createElement('img');
            img.className = 'ag-print-logo';
            img.alt = 'Logo';
            img.src = logoSrc;
            titleBar.appendChild(img);
          }
          var companyEl = document.getElementById('client-company-data');
          var companyName = companyEl ? (companyEl.getAttribute('data-company-name') || '') : '';
          var companyAddress = companyEl ? (companyEl.getAttribute('data-company-address') || '') : '';
          if (companyName) {
            var cnNode = document.createElement('div');
            cnNode.className = 'ag-print-company-name';
            cnNode.textContent = companyName;
            titleBar.appendChild(cnNode);
          }
          if (companyAddress) {
            var caNode = document.createElement('div');
            caNode.className = 'ag-print-company-address';
            caNode.textContent = companyAddress;
            titleBar.appendChild(caNode);
          }
          const titleNode = document.createElement('div');
          titleNode.className = 'ag-print-title';
          titleNode.textContent = titleText;
          titleBar.appendChild(titleNode);

          const printSubtitle = el?.dataset?.printSubtitle || '';
          if (printSubtitle) {
            const subtitleNode = document.createElement('div');
            subtitleNode.className = 'ag-print-subtitle';
            subtitleNode.textContent = printSubtitle;
            titleBar.appendChild(subtitleNode);
          }

          // Date range (From / To) from filter inputs
          try {
            const startEl = document.querySelector('[name="start_date"]');
            const endEl = document.querySelector('[name="end_date"]');
            const fromDate = (startEl && startEl.value) ? _fmtPrintDate(startEl.value.trim()) : '';
            const toDate = (endEl && endEl.value) ? _fmtPrintDate(endEl.value.trim()) : '';
            if (fromDate || toDate) {
              const dateNode = document.createElement('div');
              dateNode.className = 'ag-print-subtitle';
              dateNode.textContent = 'From : ' + (fromDate || '') + '    TO : ' + (toDate || '');
              titleBar.appendChild(dateNode);
            }
          } catch (_e) {}

          try {
            const tabInput = document.querySelector('input[name="tab"]');
            const currentTab = tabInput ? tabInput.value : '';
            let subtitleText = '';
            if (currentTab === 'productionstatus') {
              const jobidEl = document.querySelector('#jobid_input') || document.querySelector('[name="jobid"]');
              const jobidVs = document.querySelector('#jobid[data-init="virtual-select"]');
              if (jobidVs) {
                const selectedValue = (jobidEl?.value || '').trim();
                const rawOptions = jobidVs.getAttribute('data-options') || '[]';
                try {
                  const options = JSON.parse(rawOptions);
                  const matched = options.find(function(opt) {
                    return String(opt.value ?? '').trim() === selectedValue;
                  });
                  subtitleText = matched ? String(matched.label || matched.text || matched.value || '').trim() : '';
                } catch (_e) {}
              }
              if (!subtitleText && jobidEl) {
                const wrapper = jobidEl.closest('.vscomp-wrapper');
                if (wrapper) {
                  const selectedOpt = wrapper.querySelector('.vscomp-option.selected, .vscomp-option.focused');
                  subtitleText = selectedOpt ? (selectedOpt.getAttribute('data-label') || selectedOpt.textContent || '').trim() : '';
                  if (!subtitleText) {
                    const valueTxt = wrapper.querySelector('.vscomp-value')?.textContent || '';
                    const valueSpan = wrapper.querySelector('.vscomp-value-tag-content');
                    subtitleText = valueSpan ? valueSpan.textContent.trim() : valueTxt.trim();
                  }
                } else {
                  subtitleText = (jobidEl.options?.[jobidEl.selectedIndex]?.text || jobidEl.value || '').trim();
                }
              }
              if (subtitleText) subtitleText = 'JOBID: ' + subtitleText;
            } else if (currentTab === 'partwiseall') {
              const prodEl = document.querySelector('#prodgroup_input') || document.querySelector('[name="prodgroup"]');
              const prodVs = document.querySelector('#prodgroup[data-init="virtual-select"]');
              if (prodVs) {
                const selectedValue = (prodEl?.value || '').trim();
                const rawOptions = prodVs.getAttribute('data-options') || '[]';
                try {
                  const options = JSON.parse(rawOptions);
                  const matched = options.find(function(opt) {
                    return String(opt.value ?? '').trim() === selectedValue;
                  });
                  subtitleText = matched ? String(matched.label || matched.text || matched.value || '').trim() : '';
                } catch (_e) {}
              }
              if (!subtitleText && prodEl) {
                const wrapper = prodEl.closest('.vscomp-wrapper');
                if (wrapper) {
                  const selectedOpt = wrapper.querySelector('.vscomp-option.selected, .vscomp-option.focused');
                  subtitleText = selectedOpt ? (selectedOpt.getAttribute('data-label') || selectedOpt.textContent || '').trim() : '';
                  if (!subtitleText) {
                    const valueTxt = wrapper.querySelector('.vscomp-value')?.textContent || '';
                    const valueSpan = wrapper.querySelector('.vscomp-value-tag-content');
                    subtitleText = valueSpan ? valueSpan.textContent.trim() : valueTxt.trim();
                  }
                } else {
                  subtitleText = (prodEl.options?.[prodEl.selectedIndex]?.text || prodEl.value || '').trim();
                }
              }
            }
            if (subtitleText) {
              const subNode = document.createElement('div');
              subNode.className = 'ag-print-subtitle';
              subNode.textContent = subtitleText;
              titleBar.appendChild(subNode);
            }
          } catch (_e) {}
          const isoNode = document.createElement('div');
          isoNode.className = 'ag-print-iso-label';
          const reportCodes = el?.dataset?.reportCodes ? JSON.parse(el.dataset.reportCodes) : [];
          if (reportCodes.length > 0) {
            isoNode.appendChild(document.createTextNode('ISO Code - '));
            reportCodes.forEach(function(code, idx) {
              if (idx > 0) isoNode.appendChild(document.createElement('br'));
              var span = document.createElement('span');
              span.className = 'ag-print-iso-code';
              span.textContent = code;
              isoNode.appendChild(span);
            });
          }
          titleBar.appendChild(isoNode);
          el.insertBefore(titleBar, el.firstChild);
          titleEl = titleBar;
        }
        el.__printTitleId = titleId;
      }

      // Print footer with timestamp
      const footerId = `ag-print-footer-${gridId}`;
      if (!document.getElementById(footerId)) {
        const now = new Date();
        const hh = String(now.getHours()).padStart(2, '0');
        const mi = String(now.getMinutes()).padStart(2, '0');
        const footerEl = document.createElement('div');
        footerEl.id = footerId;
        footerEl.className = 'ag-print-footer';
        footerEl.textContent = 'Printed On : ' + _fmtPrintDate(now) + ' ' + hh + ':' + mi + '   Generated Using Smaac-Steel';
        document.body.appendChild(footerEl);
        el.__printFooterId = footerId;
      }
    } catch (_e) {}

    const wrapStyleId = `ag-print-wrap-style-${gridId}`;
    if (!document.getElementById(wrapStyleId)) {
      const ws = document.createElement('style');
      ws.id = wrapStyleId;
      ws.textContent = `@media print {\n  /* ensure all grid text increases, not just the wrapper */\n  [data-ag-id='${gridId}'] .ag-root-wrapper,\n  [data-ag-id='${gridId}'] .ag-root,\n  [data-ag-id='${gridId}'] .ag-body,\n  [data-ag-id='${gridId}'] .ag-body-viewport,\n  [data-ag-id='${gridId}'] .ag-center-cols-viewport,\n  [data-ag-id='${gridId}'] .ag-center-cols-container,\n  [data-ag-id='${gridId}'] .ag-cell,\n  [data-ag-id='${gridId}'] .ag-cell-value,\n  [data-ag-id='${gridId}'] .ag-header-cell-label,\n  [data-ag-id='${gridId}'] .ag-header-cell-text {\n    font-size: 18px !important;\n  }\n  /* hide grouping panel and placeholders in print */\n  [data-ag-id='${gridId}'] .ag-row-group-panel,\n  [data-ag-id='${gridId}'] .ag-column-drop,\n  [data-ag-id='${gridId}'] .ag-column-drop-empty-message {\n    display: none !important;\n  }\n  [data-ag-id='${gridId}'] .ag-cell,\n  [data-ag-id='${gridId}'] .ag-header-cell-label,\n  [data-ag-id='${gridId}'] .ag-header-cell-text {\n    white-space: normal !important;\n    overflow-wrap: anywhere;\n    word-break: break-word;\n    line-height: 1.5;\n  }\n  /* make headers larger and bold for print */\n  [data-ag-id='${gridId}'] .ag-header-cell-text,\n  [data-ag-id='${gridId}'] .ag-header-group-cell-label .ag-header-group-text {\n    font-size: 16px !important;\n    font-weight: 700 !important;\n  }\n  [data-ag-id='${gridId}'] .ag-cell,\n  [data-ag-id='${gridId}'] .ag-header-cell-label { padding: 6px 8px !important; }\n  /* header text: no clamp or ellipsis in print */\n  [data-ag-id='${gridId}'] .ag-header-cell-text {\n    display: block;\n    -webkit-line-clamp: unset;\n    -webkit-box-orient: unset;\n    overflow: visible !important;\n    text-overflow: clip !important;\n    line-height: 1.3;\n    max-height: none;\n  }\n  /* hide sort icons to free space */\n  [data-ag-id='${gridId}'] .ag-sort-indicator,\n  [data-ag-id='${gridId}'] .ag-header-icon {\n    display: none !important;\n  }\n  /* ensure header containers can grow and not clip */
    [data-ag-id='${gridId}'] .ag-header,
    [data-ag-id='${gridId}'] .ag-header-viewport,
    [data-ag-id='${gridId}'] .ag-header-row,
    [data-ag-id='${gridId}'] .ag-header-cell,
    [data-ag-id='${gridId}'] .ag-header-cell-label { overflow: visible !important; }
    /* header text: wrap at word boundaries only — never break mid-word */
    [data-ag-id='${gridId}'] .ag-header-cell-text,
    [data-ag-id='${gridId}'] .ag-header-cell-label {
      word-break: normal !important;
      overflow-wrap: normal !important;
      hyphens: none !important;
    }
    /* add slight breathing room on top to prevent header text being cut */
    [data-ag-id='${gridId}'] .ag-header,
    [data-ag-id='${gridId}'] .ag-header-row,
    [data-ag-id='${gridId}'] .ag-header-cell-label,
    [data-ag-id='${gridId}'] .ag-header-group-cell-label { padding-top: 4px !important; }
    /* remove extra space below headers */
    [data-ag-id='${gridId}'] .ag-header,
    [data-ag-id='${gridId}'] .ag-header-viewport,
    [data-ag-id='${gridId}'] .ag-header-row,
    [data-ag-id='${gridId}'] .ag-header-cell,
    [data-ag-id='${gridId}'] .ag-header-cell-label { padding-bottom: 0 !important; margin-bottom: 0 !important; }
    [data-ag-id='${gridId}'] .ag-cell-value {
      display: block !important;
      white-space: normal !important;
      overflow: visible !important;
      text-overflow: clip !important;
      line-height: 1.5 !important;
      -webkit-line-clamp: unset !important;
      -webkit-box-orient: unset !important;
      max-height: none !important;
      word-break: break-word;
      overflow-wrap: anywhere;
    }
    [data-ag-id='${gridId}'] .ag-group-value {
      display: block !important;
      white-space: normal !important;
      overflow: visible !important;
      text-overflow: clip !important;
      line-height: 1.5 !important;
      max-height: none !important;
      word-break: break-word;
      overflow-wrap: anywhere;
    }
    /* ensure cells can grow and text starts at top */
    [data-ag-id='${gridId}'] .ag-cell {
      align-items: flex-start !important;
      height: auto !important;
      overflow: visible !important;
    }
    [data-ag-id='${gridId}'] .ag-cell-wrapper {
      align-items: flex-start !important;
      height: auto !important;
      white-space: normal !important;
      overflow: visible !important;
      width: 100% !important;
    }
    /* enforce static flow so row height matches tallest cell and next row starts after */
    [data-ag-id='${gridId}'] .ag-center-cols-container,
    [data-ag-id='${gridId}'] .ag-pinned-left-cols-container,
    [data-ag-id='${gridId}'] .ag-pinned-right-cols-container,
    [data-ag-id='${gridId}'] .ag-center-cols-clipper {
      height: auto !important;
      min-height: auto !important;
      overflow: visible !important;
      position: static !important;
      transform: none !important;
    }
    [data-ag-id='${gridId}'] .ag-row,
    [data-ag-id='${gridId}'] .ag-row-position-absolute {
      position: static !important;
      top: auto !important;
      transform: none !important;
      align-items: stretch !important;
      overflow: visible !important;
      page-break-inside: avoid !important;
      break-inside: avoid !important;
    }
    /* Print must be white background + black text only -- strip all
       row/cell coloring (e.g. Production done, Already added, Item on hold) */
    [data-ag-id='${gridId}'] .ag-row,
    [data-ag-id='${gridId}'] .ag-row-position-absolute,
    [data-ag-id='${gridId}'] .ag-cell,
    [data-ag-id='${gridId}'] .ag-cell-value,
    [data-ag-id='${gridId}'] .ag-cell-wrapper,
    [data-ag-id='${gridId}'] .ag-group-value {
      background: white !important;
      background-color: white !important;
      color: black !important;
    }
    /* increase header/row heights to prevent clipping */
    [data-ag-id='${gridId}'] .ag-header,
    [data-ag-id='${gridId}'] .ag-header-viewport,
    [data-ag-id='${gridId}'] .ag-header-row { height: auto !important; min-height: 56px !important; page-break-inside: avoid; break-inside: avoid; }
    [data-ag-id='${gridId}'] .ag-row { height: auto; page-break-inside: avoid; break-inside: avoid; }
    [data-ag-id='${gridId}'] .ag-center-cols-viewport { padding-top: 0 !important; margin-top: 0 !important; }
    /* table-like borders for clear record segregation */
    [data-ag-id='${gridId}'] .ag-root-wrapper { border: 1px solid #d1d5db !important; }
    /* avoid overlap with first row: no bottom border on header row */
    [data-ag-id='${gridId}'] .ag-header-row { border-bottom: 0 !important; }
    /* header top spacing and container border adjustments */
    [data-ag-id='${gridId}'] .ag-header { position: relative !important; margin-top: 0 !important; border-top: 0 !important; }
    /* remove extra divider line under header (we will use header cell bottom borders) */
    [data-ag-id='${gridId}'] .ag-header::after { content: none !important; }
    /* CRISP, UNIFORM BORDERS ----------------------------------------------- */
    /* Header cells: draw right + bottom borders; first header cell also draws left */
    [data-ag-id='${gridId}'] .ag-header-cell,
    [data-ag-id='${gridId}'] .ag-header-group-cell {
      border: 1px solid #cbd5e1 !important; /* all sides for clear gridlines */
      box-sizing: border-box !important;
    }
    /* Body cells: draw right + bottom borders; first body cell in each row also draws left; no top border to avoid double line under header */
    [data-ag-id='${gridId}'] .ag-center-cols-container .ag-cell,
    [data-ag-id='${gridId}'] .ag-pinned-left-cols-container .ag-cell,
    [data-ag-id='${gridId}'] .ag-pinned-right-cols-container .ag-cell {
      border: 1px solid #cbd5e1 !important; /* all sides for clear gridlines */
      box-sizing: border-box !important;
    }
    /* Pinned boundaries: no extra separators; cell borders already draw lines */
    [data-ag-id='${gridId}'] .ag-pinned-left-header,
    [data-ag-id='${gridId}'] .ag-pinned-left-cols-container { border-right: 0 !important; }
    [data-ag-id='${gridId}'] .ag-pinned-right-header,
    [data-ag-id='${gridId}'] .ag-pinned-right-cols-container { border-left: 0 !important; }
    /* remove row-level borders to avoid double-thick lines */
    [data-ag-id='${gridId}'] .ag-center-cols-container .ag-row,
    [data-ag-id='${gridId}'] .ag-pinned-left-cols-container .ag-row,
    [data-ag-id='${gridId}'] .ag-pinned-right-cols-container .ag-row { border: 0 !important; }
    /* rely on uniform cell borders; no special first-row rule */
    [data-ag-id='${gridId}'] .ag-center-cols-container .ag-row:first-child .ag-cell,
    [data-ag-id='${gridId}'] .ag-pinned-left-cols-container .ag-row:first-child .ag-cell,
    [data-ag-id='${gridId}'] .ag-pinned-right-cols-container .ag-row:first-child .ag-cell { border-top-width: 1px !important; }
    /* ensure colors render as specified in print */
    [data-ag-id='${gridId}'] { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
    /* Hide header resize handles in print to avoid short stray vertical ticks */
    [data-ag-id='${gridId}'] .ag-header-cell-resize,
    [data-ag-id='${gridId}'] .ag-header-cell-resize-line { display: none !important; }
    /* Remove floating filter row and any vertical gap */
    [data-ag-id='${gridId}'] .ag-header-row.ag-header-row-floating-filter,
    [data-ag-id='${gridId}'] .ag-floating-filter,
    [data-ag-id='${gridId}'] .ag-floating-filter-body { display: none !important; height: 0 !important; min-height: 0 !important; padding: 0 !important; margin: 0 !important; border: 0 !important; }
    [data-ag-id='${gridId}'] .ag-header-viewport { height: auto !important; min-height: auto !important; padding-bottom: 0 !important; margin-bottom: 0 !important; }
    [data-ag-id='${gridId}'] .ag-header-container { padding-bottom: 0 !important; margin-bottom: 0 !important; }
    [data-ag-id='${gridId}'] .ag-center-cols-viewport { padding-top: 0 !important; margin-top: 0 !important; }
    /* Improve header text legibility versus borders */
    [data-ag-id='${gridId}'] .ag-header-cell-label,
    [data-ag-id='${gridId}'] .ag-header-group-cell-label { padding: 6px 8px 6px 8px !important; line-height: 1.2 !important; background: white !important; }
    /* Nudge header text slightly upward to clear the bottom border */
    [data-ag-id='${gridId}'] .ag-header-cell-text { position: relative; top: -0.5px; }
    /* HEADER BORDERS (print-only): slim and crisp */
    [data-ag-id='${gridId}'] .ag-header-cell,
    [data-ag-id='${gridId}'] .ag-header-group-cell {
      border: 0 !important; /* no top/bottom borders on headers */
      border-right: 1px solid #cbd5e1 !important; /* vertical separators */
      box-sizing: border-box !important;
      background: #ffffff !important;
    }
    /* avoid double line at far right edge */
    [data-ag-id='${gridId}'] .ag-header-row .ag-header-cell:last-child,
    [data-ag-id='${gridId}'] .ag-header-row .ag-header-group-cell:last-child { border-right: 0 !important; }
    [data-ag-id='${gridId}'] .ag-header-row .ag-header-cell:first-child,
    [data-ag-id='${gridId}'] .ag-header-row .ag-header-group-cell:first-child { border-left: 0 !important; }
    /* Container border (outer frame) - DARK in print view */
    [data-ag-id='${gridId}'] .ag-root-wrapper { border: 3px solid #888 !important; }
    /* Hide header resize handles to avoid stray ticks */
    [data-ag-id='${gridId}'] .ag-header-cell-resize,
    [data-ag-id='${gridId}'] .ag-header-cell-resize-line { display: none !important; }
    /* ensure colors render as specified in print */
    [data-ag-id='${gridId}'] { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
    /* Ensure checkboxes print clearly (selection stays hidden elsewhere) */
    [data-ag-id='${gridId}'] .ag-checkbox-input-wrapper,
    [data-ag-id='${gridId}'] .ag-checkbox-input,
    [data-ag-id='${gridId}'] input[type='checkbox'] {
      -webkit-appearance: none !important;
      appearance: none !important;
      width: 12px !important;
      height: 12px !important;
      border: 1px solid #374151 !important; /* gray-700 */
      border-radius: 2px !important;
      background: #ffffff !important;
      display: inline-block !important;
      position: relative !important;
      vertical-align: middle !important;
    }
 }`;
      document.head.appendChild(ws);
    }

    try { api.resetRowHeights?.(); } catch (_e) {}

    try {
      // Apply max width constraints if provided on the grid element
      try { this._applyPrintMaxWidths(el); } catch (_e) {}
      setTimeout(() => {
        try {
          api.refreshClientSideRowModel('everything');
          api.redrawRows();
          // Build a proper HTML table for print (enables header repetition + text wrapping)
          this._buildPrintTable(el);
        } catch (_e) {}
      }, 0);
    } catch (_e) {}
  },

  resetPrintLayout: function (elOrId) {
    const el = this._resolveGridElement(elOrId);
    if (!el) return;
    const gridId = el.dataset.agId;
    const api = window[`aggridApi:${gridId}`];
    if (!api) return;
    // Remove the print table and restore AG Grid's div layout
    this._removePrintTable(el);
    // Snapshot state up-front so we can safely restore later
    const prevState = el.__printState ? { ...el.__printState } : null;
    api.setGridOption('domLayout', undefined);

    if (prevState) {
      el.style.width = prevState.width;
      el.style.height = prevState.height;
      try {
        if (typeof prevState.sideBarVisible === 'boolean' && typeof api.setSideBarVisible === 'function') {
          api.setSideBarVisible(prevState.sideBarVisible);
        }
      } catch (_e) {}
    }

    this._restoreAncestorsAfterPrint(el);
    this._restoreHiddenSiblings(el);
    this._clearFixedRowHeights(el);
    try { this._restorePrintMaxWidths(el); } catch (_e) {}

    try {
      if (el.__printScroll) {
        try { window.scrollTo(el.__printScroll.pageX || 0, el.__printScroll.pageY || 0); } catch (_e) {}
        for (const s of (el.__printScroll.viewports || [])) {
          try { s.node.scrollTop = s.top; s.node.scrollLeft = s.left; } catch (_e) {}
        }
        delete el.__printScroll;
      }
    } catch (_e) {}

    const style = document.getElementById('ag-print-style');
    if (style && style.parentNode) style.parentNode.removeChild(style);

    const pageStyle = document.getElementById('ag-print-page-style');
    if (pageStyle && pageStyle.parentNode) pageStyle.parentNode.removeChild(pageStyle);

    try {
      const focusStyleId = `ag-print-focus-style-${gridId}`;
      const fs = document.getElementById(focusStyleId);
      if (fs && fs.parentNode) fs.parentNode.removeChild(fs);
      document.body.classList.remove('ag-printing');
    } catch (_e) {}
    try {
      if (prevState && prevState.pagination === true) {
        api.setGridOption('pagination', true);
      }
    } catch (_e) {}

    try {
      const toRestore = (prevState && Array.isArray(prevState.hiddenSelectionCols)) ? prevState.hiddenSelectionCols : [];
      toRestore.forEach(colKey => {
        try { api.setColumnVisible(colKey, true); } catch (_e) {}
      });
    } catch (_e) {}

    try {
      const wrap = document.getElementById(`ag-print-wrap-style-${gridId}`);
      if (wrap && wrap.parentNode) wrap.parentNode.removeChild(wrap);
    } catch (_e) {}

    try {
      const titleId = el.__printTitleId;
      if (titleId) {
        const t = document.getElementById(titleId);
        if (t && t.parentNode) t.parentNode.removeChild(t);
        delete el.__printTitleId;
      }
      const footerId = el.__printFooterId;
      if (footerId) {
        const f = document.getElementById(footerId);
        if (f && f.parentNode) f.parentNode.removeChild(f);
        delete el.__printFooterId;
      }
    } catch (_e) {}
    // Clear rowSpan caches keyed by prior row indexes and force a full refresh
    // so cell borders/lines re-render consistently after leaving print layout.
    try {
      const colDefs = (typeof api.getColumnDefs === 'function')
        ? api.getColumnDefs()
        : (api?.gridOptionsWrapper?.gridOptions?.columnDefs || []);
      if (Array.isArray(colDefs)) {
        colDefs.forEach(cd => {
          if (cd && cd.rowSpanValue) {
            try { cd.rowSpanValue = {}; } catch (_e) {}
          }
        });
      }
      try { api.refreshClientSideRowModel('everything'); } catch (_e) {}
      try { api.redrawRows({ force: true }); } catch (_e) {}
      try { api.resetRowHeights?.(); } catch (_e) {}
    } catch (_e) {}
    requestAnimationFrame(() => {
      api.doLayout?.();
      const pinnedBottomRows = api.getGridOption?.('pinnedBottomRowData');
      if (pinnedBottomRows?.length) api.setGridOption('pinnedBottomRowData', pinnedBottomRows);
    });
    // Clear stored print state at the very end
    try { delete el.__printState; } catch (_e) {}
  },

  printGrid: function (elOrId, waitMs = 300) {
    const el = this._resolveGridElement(elOrId);
    if (!el) return;
    const gridId = el.dataset.agId;
    const api = window[`aggridApi:${gridId}`];
    if (!api) return;
    const restore = () => {
      window.removeEventListener('afterprint', restore);
      try { window.ag.resetPrintLayout(el); } catch (_e) {}
      try { window.ag._hidePrintSpinner(el); } catch (_e) {}
    };
    try { window.ag._showPrintSpinner(el); } catch (_e) {}
    try { window.ag.setPrintLayout(el); } catch (_e) {}
    window.addEventListener('afterprint', restore, { once: true });

    let dynamicDelay = waitMs;
    try {
      const rows = typeof api.getDisplayedRowCount === 'function' ? api.getDisplayedRowCount() : 0;
      dynamicDelay = Math.min(8000, Math.max(waitMs, 600 + rows * 10));
    } catch (_e) {}

    try { api.doLayout?.(); api.onFilterChanged?.(); api.refreshClientSideRowModel?.('filter'); api.resetRowHeights?.(); } catch (_e) {}

    setTimeout(() => {
      try { api.redrawRows({ force: true }); } catch (_e) {}
      // Build a proper HTML table for print (enables header repetition + text wrapping)
      try { this._buildPrintTable(el); } catch (_e) {}
    
      setTimeout(() => { try { window.ag._hidePrintSpinner(el); } catch (_e) {} }, 3000);
      
      setTimeout(() => {
        try { this._applyPrintMaxWidths(el); } catch (_e) {}
        window.print();
      }, 30);
    }, dynamicDelay);
  }
};
